import { render, staticRenderFns } from "./SingleProducer.vue?vue&type=template&id=4abedc55"
import script from "./SingleProducer.vue?vue&type=script&lang=js"
export * from "./SingleProducer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports